<!--
* @Author: mouxiaowei
* @Date: 2022/1/11
* @Description:教育缴费提示APP升级
-->
<template>
  <div class="bill-upgrade">
    <img src="~@/assets/images/upgrade.png" alt="">
    <div class="bill">尊敬的用户，该功能由于升级原因，当前app版本已不适用，请点击下方按钮或通过应用市场进行版本更新。</div>
    <div class="submit-btn" @click="handleUpgrade" >立即升级</div>
  </div>
</template>

<script>
export default {
  name: 'newUpgrade',
  methods: {
    handleUpgrade () {
    //   window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      dsBridge.call('callNativeViewLifeCycle', {
        appType: '5'
      })
    }
  }
}

</script>
<style lang="scss" scoped>
.bill-upgrade {
  min-height: 100vh;
  font-size: 15px;
  position: relative;
  text-align: center;
  img {
    width: 150px;
    height: 150px;
    margin: 100px auto 0;
  }
  .bill {
    margin: 20px;
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
    color: #666;
  }
  .submit-btn {
    box-sizing: border-box;
    margin: 30px 40px;
    padding: 10px 5px;
    background: #3782fb;
    font-size: 17px;
    color: #fff;
    text-align: center;
    border-radius: 20px;
  }
}
</style>
